import { number, object, string } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';

export const variableValidationSchema = object().shape({
  stockCode: string()
    .max(50)
    .required(REQUIRED_FIELD),
  unitPrice: number()
    .typeError('Must be a number')
    .required(REQUIRED_FIELD),
  billingInterval: string(),
  billingType: string(),
  minCharge: number().typeError('Must be a number').nullable(),
  salesHandoverNumber: string()
    .max(50, 'Must be maximum ${max} characters')
    .nullable(),
  unitType: string()
    .max(10, 'Must be maximum ${max} characters')
    .nullable(),
});